// extracted by mini-css-extract-plugin
module.exports = {"dashboardHeader":"header_dashboardHeader__3Vg-K","cardContent":"header_cardContent__1wO-D","cardContent_selectors":"header_cardContent_selectors__2OeLg"};